import Layout from "../views/Layouts/DashboardLayout.vue";

import ListOrganizations from "../views/Organization/Organization/ListOrganization.vue";

export default {
  path: "/organizations",
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      path: "",
      redirect: "/organizations/management"
    },
    {
      path: "management",
      name: "Organization Management",
      component: ListOrganizations
    },
  ]
};
